import {
  base_colorAction,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_regular, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.InlineDropdown {
    position: relative;
    display: inline-flex;

    .visually-hidden {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip-path: inset(50%);
      white-space: nowrap;
      border: 0;
    }

    .inline-trigger {
      display: flex;
      align-items: center;
      gap: ${spacing(1)};
      cursor: pointer;
      background: transparent;
      border: none;
      padding: 0;
      font-family: ${font_family_weight_regular};
      color: ${text_colorTextPrimary};
      ${font_md};
      white-space: nowrap;

      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }

      &:focus-visible {
        outline: 2px solid ${base_colorAction};
        outline-offset: 2px;
        border-radius: ${spacing(1)};
      }
    }

    .inline-chevron path {
      fill: ${text_colorTextSecondary};
    }
  }
`
